<!-- INFO: component with custom css -->
<nz-layout class="app-layout !grow-0" [attr.lang]="i18nService.language" [attr.dir]="i18nService.direction">
  <!-- always show header on desktop -->
  @if (isDesktop || showHeader) {
    <nz-header class="header">
      <app-header></app-header>
    </nz-header>
  }
  <nz-layout class="layout mx-auto {{ hideSider ? '!max-w-3xl' : '' }}">
    <!-- on mobile, we show the navigation if there's no header -->
    @if (!showHeader && !isDesktop) {
      <app-top-navigation [showBackButton]="showBackButton" [title]="navTitle | translate"></app-top-navigation>
    }
    <!-- on desktop, we always show the navigation; remove the back button if in sevices category or thank you page -->
    @if (isDesktop) {
      <app-top-navigation [showBackButton]="showBackButton" [title]="navTitle | translate"></app-top-navigation>
    }

    <nz-layout class="justify-center content-shell" [class.rtl]="i18nService.isRtl">
      <!-- main content -->
      <nz-content class="p-4 md:p-6 md:mx-4 md:rounded-md2 content">
        <router-outlet></router-outlet>
      </nz-content>

      <!-- cart area -->
      @if (!hideSider) {
        <nz-sider nzWidth="350px" class="cart-sider border-solid hidden lg:block" [nzCollapsedWidth]="0">
          <app-slider-right></app-slider-right>
        </nz-sider>
      }
    </nz-layout>
  </nz-layout>
</nz-layout>
@if (showFooter) {
  <app-footer class="text-center grow flex"></app-footer>
}
